class TemplateDownloadsType {
  private elScope: HTMLElement;

  private el: {
    selectCat: HTMLSelectElement,
    selectCol: HTMLSelectElement,

    formSearch: HTMLFormElement,
    inputSearch: HTMLInputElement,
    itemsContainer: HTMLInputElement,

    itemsCat: NodeListOf<HTMLElement>,
    items: NodeListOf<HTMLElement>,

    noResultInfo: HTMLElement
  };

  constructor(elScope: HTMLElement) {
    this.elScope = elScope;
    this.el = {
      selectCat: this.elScope.querySelector('.js-t-downoads-type__scat') as HTMLSelectElement,
      selectCol: this.elScope.querySelector('.js-t-downoads-type__scol') as HTMLSelectElement,

      formSearch: this.elScope.querySelector('.js-t-downloads-t__search') as HTMLFormElement,
      inputSearch: this.elScope.querySelector('.js-t-downloads-t__search input[type="text"]') as HTMLInputElement,
      itemsContainer: this.elScope.querySelector('.js-t-downoads-type__items-c') as HTMLInputElement,

      itemsCat: this.elScope.querySelectorAll('[data-category]'),
      items: this.elScope.querySelectorAll('[data-collection]'),

      noResultInfo: this.elScope.querySelector('.js-t-downloads-t__no-result') as HTMLElement
    };
  }

  init() {
    const { el } = this;

    el.selectCat.addEventListener('change', (e: any) => this.onSelectCatChange(e.target.value, 'category', el.itemsCat));
    el.selectCol.addEventListener('change', (e: any) => this.onSelectColChange(e.target.value, 'collection', el.items));

    el.formSearch.addEventListener('submit', (e) => this.onSearch(e));
  }

  private onSelectCatChange(value: string, dataSet: string, elements: NodeListOf<HTMLElement>) {
    const { el } = this;

    const termSelected = value.toLowerCase();
    const forceShow = termSelected === 'all';

    el.selectCol.disabled = !forceShow

    elements.forEach((el) => {
      const catItems = el.querySelectorAll('.m-downloads-grid__item, .m-downloads-table__row');
      const termCurrent = el.dataset[dataSet]?.toLowerCase();
      const isHidden = !forceShow && termCurrent !== termSelected;
      catItems.forEach( (catItem) => {
        catItem.classList.toggle('is-cat-match', !isHidden);
        catItem.classList.toggle('not-cat-match', isHidden);
      })
    });

    this.handleNoResultView();
  }

  private onSelectColChange(value: string, dataSet: string, elements: NodeListOf<HTMLElement>) {
    const { el } = this;
    const collectionSelected = value.toLowerCase();
    const forceShow = collectionSelected === 'all';

    el.selectCat.disabled = !forceShow

    // Find match for each item
    elements.forEach((elItem) => {
      const currentCollections = (elItem as HTMLElement).dataset[dataSet];
      const isMatch = currentCollections?.toLowerCase().trim().includes(collectionSelected);
      const isHidden = !forceShow && !isMatch;
      elItem.classList.toggle('is-col-match', !isHidden);
      elItem.classList.toggle('not-col-match', isHidden);
    });

    this.handleNoResultView();
  }

  private handleNoResultView() {
    const { itemsCat } = this.el;

    this.toggleCategories();
    const hiddenCatCount = this.elScope.querySelectorAll('.is-hidden[data-category], .has-no-matches[data-category]').length;

    this.toggleNoResultView(hiddenCatCount == itemsCat.length);
  }

  private toggleNoResultView(show: boolean) {
    this.el.noResultInfo.classList.toggle('is-hidden', !show);
  }

  // if the category doesn't have items that "match", hide the category
  private toggleCategories() {
    const { itemsCat } = this.el;

    itemsCat.forEach((elCategory) => {
      const hasMatches = elCategory.querySelectorAll('.not-search-match, .not-cat-match, .not-col-match').length < elCategory.querySelectorAll('.m-downloads-grid__item, .m-downloads-table__row:not(.m-downloads-table__row--head)').length;
      elCategory.classList.toggle('has-matches', hasMatches);
      elCategory.classList.toggle('has-no-matches', hasMatches === false);
    });
  }

  private onSearch(e: Event) {
    e.preventDefault();

    const { itemsCat, inputSearch, items, itemsContainer } = this.el;
    const term = inputSearch.value.toLowerCase().trim();

    if (term !== '') {

      // Find match for each item
      items.forEach((elItem) => {
        const currenTerms = (elItem as HTMLElement).dataset.terms?.split(',');
        elItem.classList.add('not-search-match');
        elItem.classList.remove('is-search-match');
        currenTerms?.forEach((currenTerm) => {
          const isMatch = currenTerm.toLowerCase().trim().includes(term);
          if (isMatch) {
            elItem.classList.remove('not-search-match');
            elItem.classList.add('is-search-match');
          };
        });
      });

      this.toggleCategories();

    } else {
      items.forEach((el) => {
        el.classList.remove('not-search-match');
        el.classList.remove('is-search-match');
      });
    }
    this.handleNoResultView();

    // 80 = header height
    window.scrollTo(0, itemsContainer.getBoundingClientRect().top + window.scrollY - 80);
  }
}

export default TemplateDownloadsType;
